import React from "react"

const SectionTitle = props => (
    <h1>{props.children}</h1>
)

export default SectionTitle